module.exports = __webpack_public_path__ + "img/restaurant-11.ed389e6b.jpg";